import { useEffect } from "react";
import { LoaderComponent } from "../../components/loader/loader.component";

const AccountLocked = ({secureCreditOneCallbackUrl}) => {
  const accountLockedRedirect = secureCreditOneCallbackUrl + "?UserAccountLocked=true"
  useEffect(() => {
    window.location.replace(accountLockedRedirect);
  }, []);

  return (
    <div className="bg">
      <LoaderComponent />
    </div>
  );
};

export default AccountLocked;
